import React from 'react';

import StrokeIcon, { StrokeIconProps } from './StrokeIcon';

export default function XMarkIcon(props: StrokeIconProps): JSX.Element {
  return (
    <StrokeIcon {...props}>
      <path d="M18 6 6 18" />
      <path d="m6 6 12 12" />
    </StrokeIcon>
  );
}
